var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M4.624 1.593a1 1 0 0 1 1.752 0l3.809 6.925A1 1 0 0 1 9.309 10H1.691a1 1 0 0 1-.876-1.482z","transform":"rotate(180 5.5 5)"}})}
var staticRenderFns = []

export { render, staticRenderFns }